// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"admin","809":"protected"}[chunkId] + "." + {"328":"4ca36ce6","809":"2f4af73c"}[chunkId] + ".js";
};